import React, { useEffect, useState } from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';

import Detail from './Detail';
import Filter from 'Components/Common/Filter';

const SwBulagIndex = () => {
  document.title = "Булаг шанд";

  const [searchField, setSearchField] = useState<any>();

  useEffect(() => {
  }, [searchField])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Гадаргын ус" breadcrumbItem="Булаг шанд" />
          <Row>
            <Filter setSearchField={setSearchField} f_basin_code={true} f_au1_code={true} f_au2_code={true} f_au3_code={true} f_name={true} f_code={true} f_save_border={true} f_commonType={'cmd_spring_type'} />
            <Detail searchField={searchField} />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default SwBulagIndex;